import { all, put, takeEvery } from 'redux-saga/effects'

import { actions } from '..'
import ApiSagas from '../api/sagas'
import getArticles from '../../rest/requests/articles/articles'

export default class ArticlesSagas {
  static *onLoadRequest({
    payload,
  }: ReturnType<typeof actions.articles.loadRequest>) {
    const response = yield* ApiSagas.rest(
      getArticles(payload?.page, payload?.locale)
    )

    if (response.data) {
      yield put(actions.articles.loadSuccess(response.data))
    } else {
      yield put(actions.articles.loadError(response.errors))
    }
  }

  static *loop() {
    yield all([takeEvery(actions.articles.loadRequest, this.onLoadRequest)])
  }
}
